/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPlaceLinesResponseFromDiscriminatorValue, serializePlaceLinesRequest, serializePlaceLinesResponse, type ErrorResponse, type InternalErrorResponse, type PlaceLinesRequest, type PlaceLinesResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/place-lines
 */
export interface PlaceLinesRequestBuilder extends BaseRequestBuilder<PlaceLinesRequestBuilder> {
    /**
     * Places the selected vendor lines as one batch: one order per line, each holding only its vendor's items, header and note to the vendor, all carrying the batch id and the one signature. A line that needs terms, is under its vendor's minimum or is saved for later is reported in skipped and stays in the cart; the others are placed. Placed lines leave the cart, which is deleted once no line remains. Each new order sends one receipt, to the cart's receipt-to addresses when set. Safe to resend: lines already placed from the cart are answered with their existing orders, never placed twice. If a failure stops the batch part way, the orders already written are kept and reported in placed, the rest in failed; resending the request finishes it. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PlaceLinesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: PlaceLinesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PlaceLinesResponse | undefined>;
    /**
     * Places the selected vendor lines as one batch: one order per line, each holding only its vendor's items, header and note to the vendor, all carrying the batch id and the one signature. A line that needs terms, is under its vendor's minimum or is saved for later is reported in skipped and stays in the cart; the others are placed. Placed lines leave the cart, which is deleted once no line remains. Each new order sends one receipt, to the cart's receipt-to addresses when set. Safe to resend: lines already placed from the cart are answered with their existing orders, never placed twice. If a failure stops the batch part way, the orders already written are kept and reported in placed, the rest in failed; resending the request finishes it. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: PlaceLinesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PlaceLinesRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/place-lines";
/**
 * Metadata for all the requests in the request builder.
 */
export const PlaceLinesRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PlaceLinesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPlaceLinesResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializePlaceLinesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
